export default __webpack_public_path__ + "static/media/accordion-background-mobile.6845b8f8.png";